import { useLocation } from 'react-router-dom';
import useAuth from './useAuth';

/**
 * Hook to check if the current user is a freemium user.
 *
 * @returns boolean - true if the user has the 'freemium' role, false otherwise
 */
export const useIsFreemiumUser = (): boolean => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  return user?.getActiveTenant(pathname)?.subscription_tier === 'freemium';
};
